import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Twitter_icon from "../../../assets/images/svg/twitter_icon.svg";
import Facebook_icon from "../../../assets/images/svg/facebook_icon.svg";
import Link_icon from "../../../assets/images/svg/link_icon.svg";
import BreadCrumb from "./breadcrumb";
import { useEffect, useState } from "react";
import { webApiAutoresLista } from "../../../routes/endpoints";
import { base_url, base_url_completa, base_url_completa_codificada } from "../../../constants";
import { autoresDTO } from "../../../models/Autores.model";
import Loading from "../../../utilities/Loading";
import Alertas from "../../../utilities/Alertas";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { PlecaMorada } from "../../../utilities/PlecaMorada";

export default function Main() {
    const { id } = useParams() as { id: any };
    const [autores, setAutores] = useState<autoresDTO[]>([]);
    const [cantidadPorColumna, setCantidadPorColumna] = useState(0);
    const [cantidadAutores, setCantidadAutores] = useState(0);
    useEffect(() => {        
        window.scrollTo(0, 0)
        axios.post(webApiAutoresLista, { id_coleccion: id }).then((response) => {
                setAutores(response.data);                  
                setCantidadPorColumna(Math.ceil(Object.keys(response.data).length / 3));
                setCantidadAutores(Object.keys(response.data).length);
            })
            .catch((err) => console.warn(err));
    }, [id]);
    const cantidadToArray = () => {
        let arrayCantidad: number[] = [];
        for(let i = 0; i < cantidadPorColumna; i++){
            arrayCantidad.push(i);
        }
        return arrayCantidad;
    }
    const columnasToArray = () => {
        let arrayColumnas: number[] = [];
        for(let i = 0; i < cantidadAutores; i++){
            if(i === 0) arrayColumnas.push(i);
            if(i === 1) arrayColumnas.push(i);
            if(i === 2) arrayColumnas.push(i);
            if(i === 3) arrayColumnas = [0, 1];
            if(i === 4) {
                arrayColumnas = [0, 1, 2];
                break;
            }
        }
        return arrayColumnas;
    }
    let cantidad = cantidadToArray();
    let columnas = columnasToArray();
    let indexAutor = -1;
    const cuadro = (nombre?: string, id?:number) => {
        return (
            <div className="">
                <Link to={`/${base_url}/autores/detalle/${id}`}>
                    <div className="cuadrosAutoresListado text-center justify-content-center mx-0 ms-md-2">
                        <p className="px-2" dangerouslySetInnerHTML={{__html: `${nombre}` }}></p>
                    </div>
                </Link>
            </div>
        );
    };
    const columna = (autores: autoresDTO[]) => {
        return(
            <>
            <div className="col-12 col-md-6 col-lg-3 px-0 ">
                {
                    cantidad.map(()=>{
                        indexAutor++;
                        return ((Object.values(autores)[indexAutor]?.nombre !== undefined))? cuadro(Object.values(autores)[indexAutor]?.nombre , Object.values(autores)[indexAutor]?.id  ) : '';
                    })
                } 
            </div>
            </>
        )
    };

    if(autores.length){          
        return (
            <>
                <BreadCrumb key={Object.values(autores)[0].id} caracter={Object.values(autores)[0].sigla} url="autores" />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-11">
                            <div className="row">
                                <div className="col-12 mt-3">
                                    <div className="row">
                                        <div className="col-12 col-md-6 col-lg-3 px-0">
                                            <div className="">
                                                <div className="cuadrosAutoresListadoLetra text-center justify-content-center ms-md-2">
                                                    <p>{Object.values(autores)[0].sigla}</p>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            columnas.map( () => {
                                                return columna(autores)
                                            })
                                        }                                        
                                        <div className="row px-0">
                                            <div className="col-12 d-flex mt-2 justify-content-center justify-content-md-end align-items-center px-0">
                                                <div className="text-center">
                                                    <p className="mb-1">Compartir en:</p>
                                                    <a href={`https://twitter.com/intent/tweet?text=Revisa la obra compartida a través del sitio Editorial&url=${base_url_completa_codificada}%2Fautores%2F${id}&lang=es&via=TEPJF_informa`} target="_blank">
                                                        <img alt="icon_twitter"
                                                            src={Twitter_icon}
                                                            className="icon_socialmedia"
                                                        />
                                                    </a>
                                                    <a
                                                        href={`http://www.facebook.com/sharer.php?u=${base_url_completa}/colecciones/${id}`}
                                                        target="_blank" rel="noopener noreferrer"
                                                    >
                                                        <img alt="icon_facebook"
                                                            src={Facebook_icon}
                                                            className="icon_socialmedia"
                                                        />
                                                    </a>
                                                    <CopyToClipboard text={`${base_url_completa}/autores/${id}`}>
                                                    <img alt="icon_copiado"
                                                        role="button"
                                                        src={Link_icon}
                                                        className="icon_socialmedia"
                                                        onClick={ () =>Alertas('Ruta copiada correctamente')}
                                                    />
                                                    </CopyToClipboard>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <PlecaMorada/>
            </>
        )
    }else{
        return(
            <div className="container-fluid "> 
                <Loading/>
            </div>
        )
    }

}
